import * as Yup from "yup";

export const AdvanceDetailsSchema = Yup.object({
  reporting_address: Yup.object().shape({
    regionId: Yup.string().required("INPUT.VALIDATION.REGION"),
    address_line_1: Yup.string().required(
      "INPUT.VALIDATION.AUTOLOCATION.ADDRESSLINE1",
    ),
    country: Yup.string().required("INPUT.VALIDATION.AUTOLOCATION.COUNTRY"),
  }),
  reporting_regions: Yup.array().of(Yup.string()),
  hire_count: Yup.number(),
  supplimental_pay: Yup.array().min(
    1,
    "INPUT.VALIDATION.JOBPOST.SUPPLIMENTAL.PAY",
  ),
});
